import { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { getExtensions } from '../../../utils/swagger/utils';
import Example from './Example';
import model from './PrimitiveModel.module.scss';

const propClass = 'property primitive';

export default class PrimitiveModel extends Component {
  static propTypes = {
    schema: PropTypes.object.isRequired,
    getComponent: PropTypes.func.isRequired,
    getConfigs: PropTypes.func.isRequired,
    name: PropTypes.string,
    displayName: PropTypes.string,
    depth: PropTypes.number,
    expandDepth: PropTypes.number,
  };

  render() {
    let { schema, getComponent, getConfigs, name, displayName, depth, expandDepth, schemaType } =
      this.props;

    const { showExtensions } = getConfigs();

    if (!schema || !schema.get) {
      // don't render if schema isn't correctly formed
      return <div></div>;
    }

    let type = schema.get('type');
    let format = schema.get('format');
    let xml = schema.get('xml');
    let enumArray = schema.get('enum');
    let title = schema.get('title') || displayName || name;
    let description = schema.get('description');
    let extensions = getExtensions(schema);
    let properties = schema
      .filter((_, key) => ['enum', 'type', 'format', 'description', '$$ref'].indexOf(key) === -1)
      .filterNot((_, key) => extensions.has(key));
    const Markdown = getComponent('Markdown', true);
    const EnumModel = getComponent('EnumModel');
    const Property = getComponent('Property');
    const ModelCollapse = getComponent('ModelCollapse');
    const titleEl = title && (
      <span className="model-title">
        <span className="model-title__text">{title}</span>
      </span>
    );

    return (
      <span className="model">
        <ModelCollapse
          title={titleEl}
          // expanded={depth >= expandDepth}
          expanded={true}
          collapsedContent=" "
          hideSelfOnExpand={expandDepth !== depth}
        >
          <span className="prop primitive-model">
            {name && depth > 1 && <span className="prop-name">{title}</span>}
            {/* <span className="prop-type">{type}</span> */}
            {!description ? null : (
              <Markdown
                className={cn(model.model__desc, {
                  [model.model__desc__mini]: schemaType === 'mini',
                })}
                source={description}
              />
            )}
            {format && <span className="prop-format">(${format})</span>}
            {properties.size ? (
              <div className={model.model__properties}>
                {properties
                  .entrySeq()
                  .map(([key, v]) => (
                    <Example
                      key={`${key}-${v}`}
                      schemaType={schemaType}
                      propVal={v}
                      type={type}
                      property={key}
                    />
                  ))}
              </div>
            ) : null}
            {showExtensions && extensions.size
              ? extensions
                  .entrySeq()
                  .map(([key, v]) => (
                    <Property key={`${key}-${v}`} propKey={key} propVal={v} propClass={propClass} />
                  ))
              : null}

            {xml && xml.size ? (
              <span>
                <br />
                <span className={propClass}>xml:</span>
                {xml
                  .entrySeq()
                  .map(([key, v]) => (
                    <span key={`${key}-${v}`} className={propClass}>
                      <br />
                      &nbsp;&nbsp;&nbsp;{key}: {String(v)}
                    </span>
                  ))
                  .toArray()}
              </span>
            ) : null}
            {enumArray && (
              <EnumModel value={enumArray} getComponent={getComponent} schemaType={schemaType} />
            )}
          </span>
        </ModelCollapse>
      </span>
    );
  }
}
